import { render } from "./NotificationSelector.vue?vue&type=template&id=04c59af4&ts=true"
import script from "./NotificationSelector.vue?vue&type=script&lang=ts"
export * from "./NotificationSelector.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__